module.exports = __webpack_public_path__ + "img/wechat.26ecd437.svg";